const mutations = {
  setModels(state, data) {
    state.notaAlumnoCursados = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.notaAlumnoCursado = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.notaAlumnoCursados.unshift(model);
  },

  updateModel(state, model) {
    const index = state.notaAlumnoCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.notaAlumnoCursados.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.notaAlumnoCursados
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.notaAlumnoCursados.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
